import {
  Component,
  Input,
  OnInit,
  AfterContentInit,
  ViewChild,
  ContentChild
} from '@angular/core';
import { NativeDateAdapter, MatDialog } from '@angular/material';
import { DateAdapter } from '@angular/material/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { FileUploader } from 'ng2-file-upload';

import {
  FormGroupDef,
  FormDividerDef,
  DefaultFormGroupDef,
  DefaultFormDividerDef
} from '../templates';
import { InjectionPlaceholder } from '../internal-templates';

import * as _ from 'lodash';

@Component({
  selector: 'form-element',
  template: `
    <ng-container injectionPlaceholder></ng-container>
    <ng-container *defaultFormGroupDef="let group">
      <div class="formGroup">
        <div
          fxLayout="{{group.model.direction}} wrap"
          [fxLayoutGap]="group.model.gap"
          fxLayoutAlign="start"
        >
          <div class="formElement" *ngFor="let groupModel of group.model.items">
            <form-element
              [model]="groupModel"
              [group]="group.formGroup"
            ></form-element>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *defaultFormDividerDef="let model">
      <div class="formDivider">{{ model.placeholder }}</div>
    </ng-container>
    <ng-container [formGroup]="group" *ngIf="model.type != 'timed-callback'">
      <mat-form-field
        *ngIf="
          model.type != 'buttons' &&
          model.type != 'slider' &&
          model.type != 'datepicker' &&
          model.type != 'checkbox' &&
          model.type != 'button' &&
          model.type != 'toggle' &&
          model.type != 'group' &&
          model.type != 'divider' &&
          model.type != 'upload'
        "
      >
        <mat-icon matPrefix *ngIf="model.prefix">{{ model.prefix }}</mat-icon>
        <ng-container
          *ngIf="
            model.type == 'text' ||
            model.type == 'password' ||
            model.type == 'email' ||
            model.type == 'number'
          "
        >
          <input
            type="{{model.type}}"
            matInput
            [formControl]="group.get(model.name)"
            placeholder="{{model.placeholder}}"
            [required]="model.required"
            [autocomplete]="model.autocomplete"
          />
        </ng-container>

        <ng-container *ngIf="model.type == 'colorpicker'">
          <input
            type="text"
            [colorPicker]="group.get(model.name).value"
            [cpOutputFormat]="'rgba'"
            (colorPickerChange)="group.get(model.name).setValue($event)"
            matInput
            [formControl]="group.get(model.name)"
            placeholder="{{model.placeholder}}"
            [required]="model.required"
            [autocomplete]="model.autocomplete"
          />
          <mat-icon matSuffix [style.color]="group.get(model.name).value"
            >label</mat-icon
          >
        </ng-container>

        <ng-container *ngIf="model.type == 'textarea'">
          <textarea
            matInput
            [formControl]="group.get(model.name)"
            placeholder="{{model.placeholder}}"
            [required]="model.required"
            [ngStyle]="model.style"
          ></textarea>
        </ng-container>

        <ng-container *ngIf="model.type == 'select'">
          <mat-select
            placeholder="{{model.placeholder}}"
            [formControl]="group.get(model.name)"
            [required]="model.required"
          >
            <mat-option
              *ngFor="let item of model.items"
              [value]="lo.get(item, model.valueField)"
            >
              {{
                model.displayField
                  ? lo.get(item, model.displayField)
                  : lo.get(item, model.valueField)
              }}
            </mat-option>
          </mat-select>
        </ng-container>

        <ng-container *ngIf="model.type == 'autocomplete'">
          <input
            matInput
            placeholder="{{model.placeholder}}"
            [matAutocomplete]="auto"
            [formControl]="group.get(model.name)"
            [required]="model.required"
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let item of (filteredItems | async)"
              [value]="lo.get(item, model.valueField)"
            >
              <span>
                {{
                  model.displayField
                    ? lo.get(item, model.displayField)
                    : lo.get(item, model.valueField)
                }}</span
              >
            </mat-option>
          </mat-autocomplete>
        </ng-container>

        <mat-icon matSuffix *ngIf="model.suffix">{{ model.suffix }}</mat-icon>
        <mat-icon
          class="valid"
          matSuffix
          *ngIf="
            model.suffixValidation &&
            !group.get(model.name).pristine &&
            group.get(model.name).valid
          "
          >check</mat-icon
        >
        <mat-icon
          class="invalid"
          matSuffix
          *ngIf="
            model.suffixValidation &&
            !group.get(model.name).pristine &&
            !group.get(model.name).valid
          "
          >clear</mat-icon
        >
      </mat-form-field>

      <ng-container *ngIf="model.type == 'datepicker'">
        <mat-form-field>
          <input
            matInput
            [matDatepicker]="picker"
            placeholder="{{model.placeholder}}"
            [formControl]="group.get(model.name)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </ng-container>

      <mat-slide-toggle
        [formControl]="group.get(model.name)"
        *ngIf="model.type == 'toggle'"
        >{{ model.placeholder }}</mat-slide-toggle
      >

      <ng-container *ngIf="model.type == 'buttons'">
        <div class="ngx-form-generator-buttons">
          <div class="floated-label">{{ model.placeholder }}</div>
          <mat-button-toggle-group
            [multiple]="model.multiple"
            appearance="legacy"
            [value]="group.get(model.name).value"
            (change)="group.get(model.name).setValue(buttonGroup.value)"
            #buttonGroup="matButtonToggleGroup"
          >
            <mat-button-toggle
              [value]="item.value"
              *ngFor="let item of model.items"
            >
              <mat-icon>{{ item.icon }}</mat-icon>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </ng-container>

      <div
        ng2FileDrop
        class="formUploader"
        [uploader]="model.uploader"
        *ngIf="model.type == 'upload' && model.preview"
      >
        <ng-container *ngIf="model.filePath && checkForFile()">
          <div class="clearUpload">
            <mat-icon (click)="clearUpload()">remove_circle_outline</mat-icon>
          </div>
          <div
            class="formUploaderPreview"
            [ngStyle]="{ 'background-image': 'url(\\'' + model.filePath + '/' + checkForFile() + '\\')' }"
          ></div>
        </ng-container>
      </div>

      <input
        type="file"
        ng2FileSelect
        [uploader]="model.uploader"
        *ngIf="model.type == 'upload' && !model.preview"
      />

      <div *ngIf="model.type == 'slider'">
        <div class="floated-label">{{ model.placeholder }}</div>
        <mat-slider
          [max]="model.max"
          [min]="model.min"
          [step]="model.step"
          [formControl]="group.get(model.name)"
        >
        </mat-slider>
      </div>

      <div class="checkbox" *ngIf="model.type == 'checkbox'">
        <mat-checkbox
          (click)="checkForDialog()"
          [formControl]="group.get(model.name)"
          [required]="model.required"
          >{{ model.placeholder }}</mat-checkbox
        >
      </div>

      <button
        mat-raised-button
        [disabled]="!group.valid"
        color="{{model.color}}"
        *ngIf="model.type == 'button'"
      >
        {{ model.placeholder }}
      </button>
    </ng-container>
  `,
  styles: [
    `
      .floated-label {
        transform: scale(0.75);
        transform-origin: top left;
        font-size: 16px;
      }

      .mat-slider {
        width: 100%;
        height: 40px;
        margin-top: -8px;
      }

      .formUploader {
        width: 192px;
        height: 108px;
        border: 1px dashed grey;
      }

      .formUploaderPreview {
        width: 100%;
        height: 100%;
      }

      .clearUpload {
        position: relative;
      }

      .clearUpload > .mat-icon {
        color: red;
        position: absolute;
        cursor: pointer;
        right: 0px;
        top: 0px;
      }
    `
  ]
})
export class FormElementComponent implements OnInit, AfterContentInit {
  @ViewChild(InjectionPlaceholder) _injectionPlaceholder: InjectionPlaceholder;
  @ViewChild(DefaultFormGroupDef)
  _defaultFormGroupTemplate: DefaultFormGroupDef;
  @ViewChild(DefaultFormDividerDef)
  _defaultFormDividerTemplate: DefaultFormDividerDef;
  @ContentChild(FormGroupDef) _formGroupTemplate: FormGroupDef;
  @ContentChild(FormDividerDef) _formDividerTemplate: FormDividerDef;

  @Input() public model: any;
  @Input() public group: FormGroup;

  filteredItems: Observable<any[]>;
  lo: any = _;

  constructor(
    private dateAdapter: DateAdapter<NativeDateAdapter>,
    private dialog: MatDialog
  ) {
    this.dateAdapter.setLocale('de-DE');
  }

  filter(item) {
    return this.model.filter(this.model.items, item);
  }

  ngOnInit() {
    if (this.model.type === 'autocomplete') {
      this.filteredItems = this.group
        .get(this.model.name)
        .valueChanges.map(item => this.filter(item || ''));
    }
  }

  clearUpload() {
    this.group.get(this.model.name).patchValue(null);
  }

  checkForFile() {
    return this.group.get(this.model.name).value === undefined
      ? false
      : this.group.get(this.model.name).value;
  }

  checkForDialog() {
    if (this.model.dialog) {
      let dialogRef = this.dialog.open(this.model.dialog);
    }
  }

  ngAfterContentInit() {
    if (this.model.type === 'group') {
      this._injectionPlaceholder.viewContainer.clear();
      if (this._formGroupTemplate !== undefined) {
        this._injectionPlaceholder.viewContainer.createEmbeddedView(
          this._formGroupTemplate.template,
          {
            $implicit: {
              model: this.model,
              formGroup: this.group.get(this.model.name)
            }
          }
        );
      } else {
        this._injectionPlaceholder.viewContainer.createEmbeddedView(
          this._defaultFormGroupTemplate.template,
          {
            $implicit: {
              model: this.model,
              formGroup: this.group.get(this.model.name)
            }
          }
        );
      }
    }

    if (this.model.type === 'divider') {
      this._injectionPlaceholder.viewContainer.clear();
      if (this._formDividerTemplate !== undefined) {
        this._injectionPlaceholder.viewContainer.createEmbeddedView(
          this._formDividerTemplate.template,
          { $implicit: this.model }
        );
      } else {
        this._injectionPlaceholder.viewContainer.createEmbeddedView(
          this._defaultFormDividerTemplate.template,
          { $implicit: this.model }
        );
      }
    }
  }
}
